import { useEffect, useRef } from "react";

export function useInterval(callback: () => void, delay: number | undefined) {
	const intervalRef = useRef<number | undefined>(undefined);
	const savedCallback = useRef(callback);

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		const tick = () => {
			savedCallback.current();
		};

		if (typeof delay === "number") {
			intervalRef.current = window.setInterval(tick, delay);

			return () => {
				if (intervalRef.current !== undefined) {
					window.clearInterval(intervalRef.current);
				}
			};
		}

		return undefined;
	}, [delay]);

	return intervalRef;
}
